import { useIsAuthenticated } from "@azure/msal-react";
import environment from "../../../environment/environment";
import routes from "../common/api-routes";
import { HttpGet} from "../common/HttpRequestBuilder";


const SUBSCRIPTION_KEY = environment.service_baseUrl.subscriptionKey;
console.log("sub key xxx", SUBSCRIPTION_KEY)

const getAuthenticationCount = (startDate, endDate) => {

    let parameters = {
        startDate: startDate,
        endDate: endDate
    }
    let subscriptionKey = SUBSCRIPTION_KEY;

    let result = HttpGet(routes.GET_AUTHENTICATION_COUNT, parameters, subscriptionKey);

    return result;
}

const getAuthenticationStatus = (startDate, endDate) => {

    let parameters = {
        startDate: startDate,
        endDate: endDate
    }
    let subscriptionKey = SUBSCRIPTION_KEY;

    let result = HttpGet(routes.GET_AUTHENTICATION_STATUS, parameters, subscriptionKey);
    return result;
}


const getAuthenticationFailRate = (startDate, endDate) => {

    let parameters = {
        startDate: startDate,
        endDate: endDate
    }
    let subscriptionKey = SUBSCRIPTION_KEY;

    let result = HttpGet(routes.GET_AUTHENTICATION_FAIL_RATE, parameters, subscriptionKey);
    return result;
}

const getAuthenticationDateTypeCount = (startDate, endDate) => {

    let parameters = {
        startDate: startDate,
        endDate: endDate
    }
    let subscriptionKey = SUBSCRIPTION_KEY;

    let result = HttpGet(routes.GET_AUTHENTICATION_DATE_TYPE_COUNT, parameters, subscriptionKey);

    return result;
}


const getAuthenticationDocumentList = (page, limit) => {

    let parameters = {
        page: page,
        limit: limit
    }
    let subscriptionKey = SUBSCRIPTION_KEY;

    let result = HttpGet(routes.GET_AUTHENTICATION_DOCUMENT_LIST, parameters, subscriptionKey);
    return result;
}

const getAuthenticationDocumentListByType = (page, limit, type) => {

    let parameters = {
        page: page,
        limit: limit,
        type: type
    }
    let subscriptionKey = SUBSCRIPTION_KEY;

    let result = HttpGet(routes.GET_AUTHENTICATION_DOCUMENT_LIST, parameters, subscriptionKey);
    return result;
}


const getAuthenticationDocumentListByStatus = (page, limit, status) => {

    let parameters = {
        page: page,
        limit: limit,
        status: status
    }
    let subscriptionKey = SUBSCRIPTION_KEY;

    let result = HttpGet(routes.GET_AUTHENTICATION_DOCUMENT_LIST, parameters, subscriptionKey);
    return result;
}


const getAuthenticationProductList = (page, limit) => {

    let parameters = {
        page: page,
        limit: limit
    }
    let subscriptionKey = SUBSCRIPTION_KEY;

    let result = HttpGet(routes.GET_AUTHENTICATION_PRODUCT_LIST, parameters, subscriptionKey);
    return result;
}

const getProductAuthenticationLogs = (parameters) => {

    let query_params = parameters;
    let subscriptionKey = SUBSCRIPTION_KEY;

    let result = HttpGet(routes.GET_AUTHENTICATION_PRODUCT_LIST, query_params, subscriptionKey);
    return result;
}

const getAuthenticationProductListByProductName = (page, limit, name) => {

    let parameters = {
        page: page,
        limit: limit,
        name: name
    }
    let subscriptionKey = SUBSCRIPTION_KEY;

    let result = HttpGet(routes.GET_AUTHENTICATION_PRODUCT_LIST, parameters, subscriptionKey);
    return result;
}

const getAuthenticationProductListByProductType = (page, limit, type) => {

    let parameters = {
        page: page,
        limit: limit,
        type: type
    }
    let subscriptionKey = SUBSCRIPTION_KEY;

    let result = HttpGet(routes.GET_AUTHENTICATION_PRODUCT_LIST, parameters, subscriptionKey);
    return result;
}


const getAuthenticationProductListByProductReference = (page, limit, ovi) => {

    let parameters = {
        page: page,
        limit: limit,
        ovi: ovi
    }
    let subscriptionKey = SUBSCRIPTION_KEY;

    let result = HttpGet(routes.GET_AUTHENTICATION_PRODUCT_LIST, parameters, subscriptionKey);
    return result;
}

const getAuthenticationDateTypeCountFilterByName = (startDate, endDate, name) => {

    let parameters = {
        startDate: startDate,
        endDate: endDate,
        name: name
    }
    let subscriptionKey = SUBSCRIPTION_KEY;

    let result = HttpGet(routes.GET_AUTHENTICATION_DATE_TYPE_COUNT, parameters, subscriptionKey);

    return result;
}

const getAuthenticationCountFilterByName = (startDate, endDate, name) => {

    let parameters = {
        startDate: startDate,
        endDate: endDate,
        name: name
    }
    let subscriptionKey = SUBSCRIPTION_KEY;

    let result = HttpGet(routes.GET_AUTHENTICATION_COUNT, parameters, subscriptionKey);

    return result;
}

const getAuthenticationStatusFilterByName = (startDate, endDate, name) => {

    let parameters = {
        startDate: startDate,
        endDate: endDate,
        name: name
    }
    let subscriptionKey = SUBSCRIPTION_KEY;

    let result = HttpGet(routes.GET_AUTHENTICATION_STATUS, parameters, subscriptionKey);
    return result;
}


const getAuthenticationFailRateFilterByName = (startDate, endDate, name) => {

    let parameters = {
        startDate: startDate,
        endDate: endDate,
        name: name
    }
    let subscriptionKey = SUBSCRIPTION_KEY;

    let result = HttpGet(routes.GET_AUTHENTICATION_FAIL_RATE, parameters, subscriptionKey);
    return result;
}

const getDocumentAuthenticationViewDetails = (document_id) => {
    let parameters = {
        document_id: document_id
    }

    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpGet(routes.GET_DOCUMENT_AUTHENTICATION_VIEW_DETAILS, parameters, subscriptionKey);

    return result;
}

const getProductAuthenticationViewDetails = (product_id) => {
    let parameters = {
        product_id: product_id
    }

    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpGet(routes.GET_PRODUCT_AUTHENTICATION_VIEW_DETAILS, parameters, subscriptionKey);

    return result;
}

const getDocumentAuthenticationLogs = (parameters) => {

    let query_params = parameters;
    let subscriptionKey = SUBSCRIPTION_KEY;

    let result = HttpGet(routes.GET_AUTHENTICATION_DOCUMENT_LIST, query_params, subscriptionKey);
    return result;
}


const AuthenticationService = {
    getAuthenticationCount,
    getAuthenticationStatus,
    getAuthenticationFailRate,
    getAuthenticationDateTypeCount,
    getAuthenticationDocumentList,
    getAuthenticationProductList,
    getAuthenticationDateTypeCountFilterByName,
    getAuthenticationCountFilterByName,
    getAuthenticationStatusFilterByName,
    getAuthenticationFailRateFilterByName,
    getAuthenticationDocumentListByType,
    getAuthenticationDocumentListByStatus,
    getAuthenticationProductListByProductName,
    getAuthenticationProductListByProductType,
    getAuthenticationProductListByProductReference,
    getDocumentAuthenticationViewDetails,
    getProductAuthenticationViewDetails,
    getProductAuthenticationLogs,
    getDocumentAuthenticationLogs,
}

export default AuthenticationService
